import {HttpRequest} from '../Data/HttpRequest'
import * as R from 'ramda'
import {buildUrl} from '../Data/Http'
import {server} from '../Data/BuildEnvironment'
import {
    ProductCalculationOverviewFilterList
} from '../Pages/ProductCalculationOverview/ProductCalculationOverviewState'
import * as OffsetLimit from '../Data/OffsetLimit'

export function productCalculationList(
    manufacturerId: number,
    offsetLimit: OffsetLimit.OffsetLimit,
    filter: ProductCalculationOverviewFilterList
): HttpRequest {
    // tslint:disable-next-line
    let filterQueryParams: any = {}
    const list = ['type', 'format', 'coverage', 'print', 'paper', 'processing']

    R.forEach(
        (elem: string) => {
            if (filter[elem].value !== null) {
                let exactName = elem + 'IsExact'
                filterQueryParams[elem] = filter[elem].value
                filterQueryParams[exactName] = (filter[elem].exact) ? '1' : '0'
            }
        },
        list
    )

    return {
        verb: 'GET',
        url:
            buildUrl(
                `${server}/manufacturers/${manufacturerId}/product-calculation-list`,
                {
                    ...filterQueryParams,
                    ...OffsetLimit.toQueryParameters(offsetLimit),
                }),
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Request/ProductCalculationListRequest.ts